import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactHighcharts from "react-highcharts";
import HighchartsMore from "highcharts-more";
import Pareto from "highcharts/modules/pareto";
import SolidGauge from "highcharts/modules/solid-gauge";
import classNames from 'classnames';
import {commercialHoursInInterval, convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import Grid from "@material-ui/core/Grid/Grid";
import ComplexGrid from "../../../common/ComplexGrid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {checkNull} from "../../../utils/utils";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {};
var perioddata = [];
var cH = null;

const useStyles = makeStyles(theme => ({

  mainGrid: {
   // backgroundColor: 'cyan',
      margin: '6px 0px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch'
  },
  marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      margin: '8px',
      border: '3px',
      borderColor: 'yellow',
    // display: 'flex',
    //   flexGrow: '0.2',
      // width: '100%',
    //   height: '100%'
  }
}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function RaspaKPIs(prop) {
  const {series, seriesPerType, filter, isLoading} = prop;
  console.log('kpi series', series)
  const classes = useStyles();
  let dataok = false;
  let tciclos = null;
  var tenergia = null;
  var perioddata = [0];

  //
  const e = filter.estabelecimentos.find( e => e.id === filter.estabelecimentoId);
  const cHD = e? e.cargaHorariaDia : 8;

  if (series) {

    dataok = true;
    series.map(i => {
      perioddata[0] = Math.round(i.TotalTempoCiclo / 60 / 60 * 10) / 10;
      tciclos = i.Ciclos;
      tenergia = Math.round(i.EnergiakWh * 10) / 10;
    })
    cH = commercialHoursInInterval(filter.periodMin, filter.periodMax, cHD);

  }

  var percent = Math.round(perioddata[0] / cH * 100);
  var dataMaq = null;
  var dataOper = null;


  if (seriesPerType) {
    seriesPerType.map(i => {
      dataMaq = convertSecondsToMinutesSecondsFormat(Math.round((i.TotalTempoCiclo - i.TotalTempoWait) / i.Ciclos));
      dataOper = Math.round(i.TotalTempoWait / i.Ciclos);
    })
  }
  tenergia = tenergia / tciclos;


  if (isLoading) {return renderLoadingScreen()}

  return (
    <Grid container xs={12} className={classes.mainGrid}>
      <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            leftSideGrid={true}
          iconState="success"
          icon="business_money-coins"
          mainvalue={<span><small></small>
            {checkNull(tciclos, '--')}</span>}
          title={<span>PRODUÇÃO</span>}
            description={<span>em {cH} {cHD} horas disponíveis.</span>}
            unit="ciclos"
        />
      </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            mainvalue={<span>{checkNull(percent,'--')}%</span>}
          title={<span>UTILIZAÇÃO</span>}
          description={<span>{perioddata[0]}h em {cH} horas disponíveis.</span>}
            unit="percentual"
        />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
          mainvalue={checkNull(dataMaq+'', '--')}
          title='TEMPO MÉDIO TOTAL'
          unit='minutos'
          description={<span>tempo médio total por raspagem</span>}

        />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
          mainvalue={checkNull(dataOper+'','--')}
          title={<span>ESPERA OPERADOR</span>}
          description={<span>espera incluida no tempo total.</span>}
          unit={<span>segundos</span>}
        />
        </Grid>
        <Grid item className={classNames(classes.marginAuto)}>
        <ComplexGrid
            className={classes.marginAuto}
            rightSideGrid={true}
            mainvalue={<span>{checkNull(tenergia.toPrecision(3), '--')  }</span>}
            title={<span>POTÊNCIA</span>}
            description={<span>consumo de energia por ciclo</span>}
            unit={<span>kiloWatt</span>}

        />
        </Grid>
    </Grid>
  )
}
;
